const styles = () => ({
  form: {
    padding: '10px 10px 30px'
  },
  container: {
    display: 'flex',
    maxWidth: '386px'
  },
  field: {
    width: '250px'
  },
  btn: {
    flexShrink: 0,
    marginLeft: '10px'
  }
})

export default styles
